export const colors = {
  BRIGHT_PURPLE: "#7a0ed9",
  ORANGE: "#ff8000",
  WHITE: "#ffffff",
  SKY_BLUE: "#dae4f2",
  LIGHT_BLUE_1: "#edf5ff",
};
